(() => {
  const INSTALL_KEY = '__nuovaluceAutoSilverGelGiftV1';
  if (window[INSTALL_KEY]) return;
  window[INSTALL_KEY] = true;

  const GIFT_VARIANT_ID = '45266222645363';
  const GIFT_PROPERTY = '_nl_gwp_auto';
  const GIFT_MARKER = '50-off-silver-gel-v1';
  const QUALIFYING_PRODUCTS = new Set([
    '8340726743155',
    '8340726874227',
    '8340726906995',
    '8340727038067',
    '8340727234675',
    '8340727267443',
    '8340727332979',
    '8340727365747',
    '8831956942963',
  ]);

  const nativeFetch = window.fetch.bind(window);
  let syncQueue = Promise.resolve();
  let reloadScheduled = false;

  function routeUrl(route, suffix) {
    const url = new URL(route || suffix, window.location.origin);
    if (suffix && !url.pathname.endsWith('.js')) url.pathname += '.js';
    return url.href;
  }

  function getMutationType(input, init) {
    const requestObject = typeof Request !== 'undefined' && input instanceof Request;
    const method = String((init && init.method) || (requestObject && input.method) || 'GET').toUpperCase();
    if (method !== 'POST') return null;

    try {
      const url = new URL(requestObject ? input.url : input, window.location.href);
      if (url.origin !== window.location.origin) return null;
      const match = url.pathname.match(/\/cart\/(add|change|update)(?:\.js)?\/?$/);
      return match ? match[1] : null;
    } catch (_) {
      return null;
    }
  }

  async function getCart() {
    const route = (window.routes && window.routes.cart_url) || '/cart';
    const response = await nativeFetch(routeUrl(route, '.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`cart_read_failed_${response.status}`);
    return response.json();
  }

  async function changeLine(key, quantity) {
    const route = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    const response = await nativeFetch(routeUrl(route, '.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status || data.errors) {
      throw new Error(data.description || data.message || `cart_change_failed_${response.status}`);
    }
  }

  async function addGift() {
    const route = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    const response = await nativeFetch(routeUrl(route, '.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: { [GIFT_PROPERTY]: GIFT_MARKER },
        }],
      }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status || data.errors) {
      throw new Error(data.description || data.message || `gift_add_failed_${response.status}`);
    }
  }

  async function syncGift() {
    let cart = await getCart();
    const items = Array.isArray(cart.items) ? cart.items : [];
    const qualifies = items.some((item) => QUALIFYING_PRODUCTS.has(String(item.product_id)));
    const gifts = items.filter((item) => String(item.variant_id) === GIFT_VARIANT_ID);
    const autoGifts = gifts.filter((item) => item.properties && item.properties[GIFT_PROPERTY] === GIFT_MARKER);
    const manualGiftCount = gifts
      .filter((item) => !(item.properties && item.properties[GIFT_PROPERTY] === GIFT_MARKER))
      .reduce((total, item) => total + Number(item.quantity || 0), 0);

    // The live BXGY discount is limited to one free gel per order.
    const desiredAutoGiftCount = qualifies && manualGiftCount < 1 ? 1 : 0;
    let changed = false;

    if (desiredAutoGiftCount > 0 && autoGifts.length === 0) {
      await addGift();
      changed = true;
    } else if (desiredAutoGiftCount > 0 && Number(autoGifts[0].quantity) !== desiredAutoGiftCount) {
      await changeLine(autoGifts[0].key, desiredAutoGiftCount);
      changed = true;
    }

    const keepOne = desiredAutoGiftCount > 0 ? autoGifts[0] : null;
    for (const item of autoGifts) {
      if (!keepOne || item.key !== keepOne.key) {
        await changeLine(item.key, 0);
        changed = true;
      }
    }

    if (changed) cart = await getCart();
    return { changed, cart };
  }

  function queueSync() {
    const next = syncQueue.catch(() => undefined).then(syncGift);
    syncQueue = next;
    return next;
  }

  async function renderSections(sectionIds) {
    if (!sectionIds.length) return null;
    const root = (window.routes && window.routes.root_url) || '/';
    const url = new URL(root, window.location.origin);
    url.searchParams.set('sections', sectionIds.join(','));
    url.searchParams.set('sections_url', window.location.pathname);
    const response = await nativeFetch(url.href, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data && typeof data === 'object' ? data : null;
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function scheduleCartReload() {
    if (!isCartPage() || reloadScheduled) return;
    reloadScheduled = true;
    window.setTimeout(() => window.location.reload(), 50);
  }

  function rebuildResponse(response, data) {
    const headers = new Headers(response.headers);
    headers.delete('content-length');
    headers.delete('content-encoding');
    return new Response(JSON.stringify(data), {
      status: response.status,
      statusText: response.statusText,
      headers,
    });
  }

  function showGiftError() {
    let notice = document.getElementById('nuovaluce-auto-gwp-error');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'nuovaluce-auto-gwp-error';
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'position:fixed;z-index:2147483647;left:16px;right:16px;bottom:16px;padding:14px 16px;border-radius:8px;background:#fff4e5;color:#573400;border:1px solid #e5c58b;box-shadow:0 8px 30px rgba(0,0,0,.18);font:14px/1.4 system-ui,sans-serif;';
      document.body.appendChild(notice);
    }
    notice.textContent = 'We could not add the free Silver Conductive Gel. Please refresh your cart before checkout.';
  }

  window.fetch = function (input, init) {
    const mutationType = getMutationType(input, init);
    const originalPromise = nativeFetch(input, init);
    if (!mutationType) return originalPromise;

    return originalPromise.then(async (response) => {
      if (!response.ok) return response;
      let data;
      try {
        data = await response.clone().json();
      } catch (_) {
        return response;
      }
      if (!data || data.status || data.errors) return response;

      let result;
      try {
        result = await queueSync();
      } catch (error) {
        console.error('[Nuovaluce auto gift]', error);
        showGiftError();
        return response;
      }
      if (!result.changed) return response;

      const sectionIds = data.sections && typeof data.sections === 'object' ? Object.keys(data.sections) : [];
      let freshSections = null;
      if (sectionIds.length) {
        try {
          freshSections = await renderSections(sectionIds);
          if (freshSections) data.sections = { ...data.sections, ...freshSections };
        } catch (error) {
          console.error('[Nuovaluce cart sections]', error);
        }
      }

      if (mutationType === 'change' || mutationType === 'update') {
        const sections = data.sections;
        data = { ...data, ...result.cart };
        if (sections) data.sections = sections;
      }

      if (!sectionIds.length && isCartPage()) scheduleCartReload();
      return rebuildResponse(response, data);
    });
  };

  queueSync()
    .then(({ changed, cart }) => {
      const onCartPage = isCartPage();
      if (changed && onCartPage) scheduleCartReload();
      if (changed && !onCartPage && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nuovaluce-auto-gwp', cartData: cart });
      }
    })
    .catch((error) => {
      console.error('[Nuovaluce auto gift]', error);
      showGiftError();
    });
})();
